import React from 'react'
import { connect } from 'react-redux'
import { brand } from '@r/app-selectors'
import { TruArrow } from '@uswitch/spark-icons/tru'
import Icon from '../icon'

interface ButtonProps {
  dataClickTracking?: any
  dataAction?: string
  disabled?: boolean
  variant?: 'primary' | 'secondary' | 'tertiary' | 'icon'
  size?: 'lg' | 'md' | 'sm' | 'mdTriage'
  type?: 'submit' | 'reset' | 'button'
  style?: object
  brand: 'money' | 'uswitch'
  children: React.ReactNode
  withIcon?: boolean
  href?: string
  onClick?: any
}

const Button = ({
  dataClickTracking = {},
  dataAction,
  disabled = false,
  variant = 'primary',
  size = 'lg',
  type = 'button',
  style = {},
  brand,
  children,
  withIcon,
  href,
  onClick,
}: ButtonProps) => {
  if (variant === 'icon') {
    return (
      <button className='icon_atom' disabled={disabled}>
        <Icon
          color={brand === 'money' ? '#FEAF00' : '#141424'}
          glyph={brand === 'money' ? 'right-arrow-button' : 'right-arrow-button-uswitch'}
          size={brand === 'money' ? 45 : 36}
        />
      </button>
    )
  }
  const iconClass = withIcon ? 'button_atom_icon' : ''

  const component = () => (
    <button
      type={type}
      className={`button_atom button_atom__${variant} button_atom__${size} ${iconClass}`}
      disabled={disabled}
      data-click-tracking={JSON.stringify(dataClickTracking)}
      data-action={dataAction}
      style={style}
      onClick={onClick}
    >
      {children}
      {withIcon && <TruArrow className='button_icon' />}
    </button>
  )

  return href ? <a href={href}>{component()} </a> : component()
}

export default connect((state, props) => {
  return {
    brand: brand(state),
    ...props,
  }
})(Button)
